// extracted by mini-css-extract-plugin
export default {"PageHome":"PageHome_PageHome__RUxz3","Informations":"PageHome_Informations__5T94x"};